export const searchPaths = [
  { locale: 'de', path: 'suche' },
  { locale: 'fr', path: 'recherche' },
];
